// extracted by mini-css-extract-plugin
export var animationContainer = "_g4-0";
export var footer = "_g4-1";
export var gray = "_g4-2";
export var lineItem = "_g4-3";
export var lineItemImage = "_g4-4";
export var lineItemInfo = "_g4-5";
export var lineItemText = "_g4-6";
export var lineItems = "_g4-7";
export var modalContent = "_g4-8";
export var options = "_g4-9";
export var orderName = "_g4-a";
export var refundAmount = "_g4-b";